import type { ReactNode } from "react";
import { cx } from "@/shared/lib/cx";
import type { IconComponent, Tone } from "./types";

const variants: Record<Tone, string> = {
  info: "badge-info bg-primary/10 text-primary",
  success: "badge-success bg-success/10 text-success",
  warning: "badge-warning bg-warning/10 text-warning",
  error: "badge-error bg-error/10 text-error",
  neutral: "badge-ghost bg-base-200 text-muted",
};

export function StatusBadge({
  children,
  tone = "neutral",
  icon: Icon,
  className,
}: {
  children: ReactNode;
  tone?: Tone;
  icon?: IconComponent;
  className?: string;
}) {
  return (
    <span className={cx("badge badge-sm gap-1 border-0 font-semibold", variants[tone], className)}>
      {Icon && <Icon className="size-3" aria-hidden="true" />}
      {children}
    </span>
  );
}
